export default {
  /**
   *  @type {string} 検索画面
   */
  search: '/admin/template/',
  /**
   * 参照画面
   * @param {string} id 社員ID
   */
  refer: (id) => {
    return `/admin/template/refer/${id}`;
  },
  /**
   * 編集画面
   * @param {string} id 社員ID
   */
  edit: (id) => {
    return `/admin/template/edit/${id}`;
  },
};
